import React, { useState, useEffect } from "react";
import { useNotify } from "react-admin";
import {
  Box,
  Button,
  Typography,
  CircularProgress,
  Switch,
  FormControlLabel,
  TextField,
  Stack,
  Divider,
} from "@mui/material";
import { apiGet, apiPatch } from "../../utils/apiClient";

const DEFAULTS = {
  multiDayRentalEnabled: true,
  maxRentalDays: 10,
  paymentAtBeginning: true,
};

export default function LocationFeatureFlagsTab({ locationId }) {
  const [flags, setFlags] = useState(null);
  const [saving, setSaving] = useState(false);
  const notify = useNotify();

  useEffect(() => {
    apiGet(`locations/${locationId}/feature-flags`)
      .then(setFlags)
      .catch(() => setFlags(DEFAULTS));
  }, [locationId]);

  const handleSave = async () => {
    setSaving(true);
    try {
      const updated = await apiPatch(
        `locations/${locationId}/feature-flags`,
        flags
      );
      setFlags(updated);
      notify("Feature flags updated", { type: "success" });
    } catch {
      notify("Error updating feature flags", { type: "error" });
    } finally {
      setSaving(false);
    }
  };

  if (!flags) return <CircularProgress sx={{ m: 2 }} />;

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Multi-Day Rental Settings
      </Typography>
      <Stack spacing={3} sx={{ maxWidth: 400 }}>
        <FormControlLabel
          control={
            <Switch
              checked={flags.multiDayRentalEnabled}
              onChange={(e) =>
                setFlags({ ...flags, multiDayRentalEnabled: e.target.checked })
              }
            />
          }
          label="Multi-Day Rental Enabled"
        />
        <TextField
          type="number"
          label="Max Rental Days"
          value={flags.maxRentalDays}
          onChange={(e) =>
            setFlags({
              ...flags,
              maxRentalDays: Math.max(1, parseInt(e.target.value) || 1),
            })
          }
          disabled={!flags.multiDayRentalEnabled}
          inputProps={{ min: 1 }}
          size="small"
        />
        <Divider />
        <Typography variant="h6">Payment Settings</Typography>
        <FormControlLabel
          control={
            <Switch
              checked={flags.paymentAtBeginning}
              onChange={(e) =>
                setFlags({ ...flags, paymentAtBeginning: e.target.checked })
              }
            />
          }
          label="Payment at beginning (card authorized at dropoff)"
        />
        <Box>
          <Button variant="contained" onClick={handleSave} disabled={saving}>
            {saving ? "Saving…" : "Save"}
          </Button>
        </Box>
      </Stack>
    </Box>
  );
}
